var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.6074696,36.7240138 L26.036041,21.7775853 C29.3600273,18.5574735 34.6399727,18.5574735 37.963959,21.7775853 L53.3925304,36.7240138 C55.0591807,38.3385813 56,40.559895 56,42.8803586 L56,43.125 C56,44.0314233 55.2651987,44.7662246 54.3587754,44.7662246 C53.932515,44.7662246 53.5229765,44.6003835 53.2168191,44.3037935 L37.963959,29.5275853 C34.6399727,26.3074735 29.3600273,26.3074735 26.036041,29.5275853 L10.7831809,44.3037935 C10.1321512,44.9344786 9.0931161,44.9179859 8.46243108,44.2669562 C8.16584117,43.9607989 8,43.5512604 8,43.125 L8,42.8803586 C8,40.559895 8.9408193,38.3385813 10.6074696,36.7240138 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIcon);
export default __webpack_public_path__ + "static/media/up-icon.94ba94c980bf4c17054f4c663a5e3d7b.svg";
export { ForwardRef as ReactComponent };